
import { Vue, Component, Prop } from "vue-property-decorator";
import { CreationResponse } from "../../Models/CreationResponse";
import router from "@/router";

@Component({})
export default class ResponseModal extends Vue {
  @Prop({ type: Object as () => CreationResponse })
  public response!: CreationResponse;
  @Prop()
  public branding!: string;

  public get isSuccess() {
    return (
      this.response.Type === "ContactCreated" ||
      this.response.Type === "VerificationResent"
    );
  }
}
